export default __webpack_public_path__ + "static/media/vod-small.9e087b24.jpg";